import { Link } from "react-router-dom"
import { getLists, refreshContactsListCount } from "../../api/axios"
import { useState, useEffect } from "react";
import { day, getBrandClassName } from "../../utilities/Utils"
import useAuth from "../../hooks/useAuth";
import LoadingContainer from "../../components/LoadingContainer";

const ListsTable = ({ params = {} }) => {

const [isLoading, setIsLoading] = useState(true);
const [error, setError] = useState(null);
const [lists, setLists] = useState([]);
const [updatingListId, setUpdatingListId] = useState(null);
const [updatingError, setUpdatingError] = useState(null);

const { auth } = useAuth();
const { idBrand = '0', idContactType = '0', name = '' } = params;

useEffect(() => {

  const fetchData = async () => {
      
    setIsLoading(true);
    
    try {
      
      const data = await getLists({
        props: {
          params: {
            idBrand,
            idContactType,
            name,
          },
        },
        auth,
      });
      setLists(data.results);
      setError(null);

    } catch (error) {

      setError(error);
      setLists([]);

    }

    setIsLoading(false);

  };


  fetchData();
    
}, [auth, idBrand, idContactType, name]);

  
  const handleRefreshContacts = async (contactListId) => {

    setUpdatingListId(contactListId);
    setUpdatingError(null);

    try {

      const data = await refreshContactsListCount(contactListId, auth);
      const updatedList = data.results;

      setLists((currentLists) => {
        if (!Array.isArray(currentLists)) {
          return currentLists;
        }

        return currentLists.map((list) => (
          String(list.id) === String(contactListId)
            ? { ...list, ...updatedList }
            : list
        ));
      });

    } catch (error) {

      setUpdatingError(contactListId);

    }

    setUpdatingListId(null);

  };

  const formatContactsCount = (value) => {
    return value === null || value === undefined || value === '' ? '-' : value;
  };


  const hasLists = Array.isArray(lists) && lists.length > 0;

  return (

    <LoadingContainer isLoading={isLoading}>
          
      <table className="table table--enhanced table--wide">
                      
        <thead>
            <tr>
                <td>ID / Marca</td>
                <td>Tipo de destinatario</td> 
                <td>Nombre</td> 
                <td>Destinatarios</td> 
                <td>Fecha Actualización</td> 
                <td>Acción</td> 
                <td>Fecha Alta</td> 
            </tr>
        </thead>
        <tbody>
            {error && (
              <tr>
                <td colSpan="7" className="c loading">
                  No se pudo cargar el listado de listas de destinatarios
                  {error?.response?.data?.message ? `: ${error.response.data.message}` : ''}
                </td>
              </tr>
            )}
            {!isLoading && !error && !hasLists && (
              <tr><td colSpan="7" className="c loading">No se encontraron resultados</td></tr>
            )}
            {!isLoading && !error && hasLists && lists.map( item => (

              <tr key={item.id}>
                  
                  <td>
                    <div className="table-identity">
                    <Link className="vinculo table-id-pill" to={`/contacts-lists/edit/${item.id}`}>{item.id}</Link>
                    <span className={getBrandClassName(item.brand_name, 'table-brand-label')}>{item.brand_name}</span>
                    </div>
                  </td>

                  <td>
                    <span className="table-secondary">{item.contact_type_name}</span>
                  </td>
                  
                  <td>
                    <span className="table-primary">{item.name}</span>
                  </td>
                  
                  <td className="c">
                    <span className="table-metric">
                      <strong>{formatContactsCount(item.contacts)}</strong>
                      <span>dest.</span>
                    </span>
                  </td>
                  
                  <td className="c">
                    <span>{day(item.updated_at)}</span>
                  </td>

                  <td className="c">
                    <button
                      type="button"
                      className="table-action-pill"
                      disabled={updatingListId === item.id}
                      onClick={() => handleRefreshContacts(item.id)}
                    >
                      {updatingListId === item.id ? 'Actualizando' : 'Actualizar'}
                    </button>
                    {updatingError === item.id && (
                      <div className="table-error">No se pudo actualizar</div>
                    )}
                  </td>
                  
                  <td className="c">
                    <span>{day(item.created_at)}</span>
                  </td>
                  
              </tr>
            ))}
            
        </tbody>

      </table>
    </LoadingContainer>
    
    )
}

export default ListsTable
